import axiosCilent from "./axiosClient";
import { Result } from "../model/Result";

// ログイン情報PDF再作成APIリクエスト
export const requestLoginInfoPDFRecreate = async (
    loginPdfCreateStatesId: string, 
): Promise<Result> => {
  try{
    const response = await axiosCilent.post(`pdfReCreate`, {loginPdfCreateStatesId});
    return response.data;
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};